import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const listRoute: InvariantJiraRoute = {
	name: 'servicedesk-list',
	path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/list',
	exact: true,
};
